import Link from "next/link";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// bricostore-only pagination overrides (circular shape + red active border); altex/MG untouched
// replace (not append) the radius so there's a single rounded-* class → no cascade conflict
const pageRadius = isBricoStore ? "rounded-full" : "rounded-md";
const activePageClass = isBricoStore
  ? "bg-red-brand text-white border-red-brand"
  : "bg-alertRed text-white";

const ButtonWrapper = ({ url, isActive, children }) => {
  if (url && !isActive) {
    return (
      <Link href={url}>
        <a className={`mx-0.5 sm:mx-1 text-sm flex w-8 h-8 items-center justify-center border border-gray-1100 ${pageRadius} bg-white`}>
          {children}
        </a>
      </Link>
    );
  }

  return (
    <div
      className={`mx-0.5 sm:mx-1 text-sm flex w-8 h-8 items-center justify-center border border-gray-1100 ${pageRadius} ${
        isActive ? activePageClass : "text-gray"
      }`}
    >
      {children}
    </div>
  );
};

export default ButtonWrapper;
